import { RelationshipActions } from '../../../actions/relationship';
import { validateAndDispatch } from '../../../helpers/form';

const helpers = {

  getWbsPathStringFromRelationships(relationships, wbsRelTypeId, elements, elementId){
    // assume only one WBS relationship
    const wbsRel = Array.from(relationships.values()).find(rel => (rel.get('type_id')===wbsRelTypeId && rel.get('consumer')===elementId));
    if (wbsRel) {
      const wbsparentId = wbsRel.get('producer');
      const wbsParentName = elements.get(wbsparentId).get('name');
      return wbsParentName;
    }
    return '';
  },
  // Extracts element ids from relationships that match typeOptions
  getElementIdsfromRelationships(
      elementId, typeOptions,
      relationships, providesToConsumesFrom) {
    // Check to prevent multi-edit from crashing because it doesn't work yet
    if (!providesToConsumesFrom || !relationships) return [];

    const relType = (typeOptions && typeOptions['[RT]relationship_type']) || '';
    const relDirection = (typeOptions && typeOptions.relationship_direction) || 'consumesFrom';

    const rels = (relDirection === 'consumesFrom')
      ? providesToConsumesFrom.get('consumesFrom')
      : providesToConsumesFrom.get('providesTo');

    return rels.reduce(
      (l, r) => {
        const rel = relationships.get(r);
        if (rel) {
          const producer = rel.get('producer');
          const consumer = rel.get('consumer');
          const type = rel.get('type_id');

          let testElementId;
          let otherElementId;
          if (relDirection !== 'consumesFrom') {
            testElementId = producer;
            otherElementId = consumer;
          } else {
            testElementId = consumer;
            otherElementId = producer;
          }

          if (relType === type && testElementId === elementId) {
            l.push(otherElementId);
          }
        }
        return l;
      },
      [],
    );
  },

  // Get elements of specified types
  populateOptions(typeOptions, elements, currentElementId) {
    // Get the element types to be filtered
    let types = (typeOptions && typeOptions['[ET]element_type']) || [];
    if (typeof types === 'string') {
      types = types.split(',');
    }

    // Obtain elements of the selected types (excluding current element)
    let output = elements.reduce((acc, e) => {
      if (types.indexOf(e.get('type_id')) !== -1) {
        const value = e.get('name');
        const id = e.get('id');
        if (currentElementId !== id && value !== 'WBS Root') {
          acc.push({
            label: value,
            value: id,
          });
        }
      }
      return acc;
    }, []);

    // Sort the list
    output = output.sort((a, b) => {
      const labelA = a.label.toUpperCase();
      const labelB = b.label.toUpperCase();
      if (labelA < labelB) return -1;
      else if (labelA > labelB) return +1;
      return 0;
    });

    if (typeOptions && !typeOptions.multi_relationship) {
      output.unshift({ label: 'None', value: 'None' });
    }

    return output;
  },

  // Adds the relationships that were selected by the user
  async editSubmit(elementProp, dispatch, projectId, els, typeOptions) {
    const elementIds = (Array.isArray(els)) ? els : [els];
    const propKey = Object.keys(elementProp)[0];
    const value = elementProp[propKey];
    const newValues = (value && (value !== 'None')) ? value.split(',') : [];

    const relationshipType = (typeOptions && typeOptions['[RT]relationship_type']) || '';
    const relationshipDirection = (typeOptions && typeOptions.relationship_direction)
                                  || 'consumesFrom';

    const len = elementIds.length;
    for (let i = 0; i < len; i++) {
      const elementId = elementIds[i];
      let otherElementIds;
      if (typeOptions.multi_relationship) {
        otherElementIds = newValues;
      } else {
        otherElementIds = [];
        if (newValues.length > 0) {
          otherElementIds.push(newValues[0]);
        }
      }

      const addAction = RelationshipActions.patchRelationships(
        {
          relationshipDirection,
          relationshipType,
          elementId,
          otherElementIds,
          strength: 1,
        },
        projectId,
      );

      if (addAction) {
        await validateAndDispatch(dispatch, addAction, {}, {});
      }
    }
  },

  // Used to add relationships created as part of new element modal
  async postCreate(elementProp, dispatch, projectId, newIds, typeOptions) {
    // console.log('After from submit: ', elementProp, newIds, typeOptions);
    const direction = (typeOptions && typeOptions.relationship_direction);
    const relationshipType = (typeOptions && typeOptions['[RT]relationship_type']);
    if (!relationshipType) throw new Error('Invalid relationship type');
    // console.log('after submit elementProp: ', elementProp);
    const targets = (elementProp && (elementProp !== 'None')) ? elementProp.split(',') : [];

    // Create relationship objects for the action
    const relationshipsToAdd = [];
    const targetlen = targets.length;
    for (let i = 0; i < targetlen; i++) {
      const target = targets[i];
      const len = newIds.length;
      for (let j = 0; j < len; j++) {
        const newId = newIds[j];
        let consumer;
        let producer;
        if (direction === 'consumesFrom') {
          consumer = newId;
          producer = target;
        } else if (direction === 'providesTo') {
          consumer = target;
          producer = newId;
        } else {
          throw new Error('Invalid relationship direction');
        }
        const obj = {
          consumer,
          producer,
          relationshipTypeId: relationshipType,
          project_id: projectId,
          strength: 1,
        };
        relationshipsToAdd.push(obj);
      }
    }

    // Create the action
    const action = RelationshipActions.createRelationships(relationshipsToAdd, projectId);

    // Dispatch the action
    await dispatch(action);
  },

};

export default helpers;



// WEBPACK FOOTER //
// ./src/components/types/RelationshipSelect/helpers.js